var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "ci-user-profile-company ci-card ci-section ci-content-padding",
    },
    [
      _c("h3", {
        staticClass: "h5 m-0 text-center",
        domProps: {
          textContent: _vm._s(_vm.$t("ui.components.users.profile.company")),
        },
      }),
      _c(
        "ci-router-link",
        { attrs: { to: _vm.company.url } },
        [
          _c("ci-imgix-lazy", {
            staticClass: "company-logo centered-logo",
            attrs: {
              url: _vm.company.logo_url,
              params: { height: 80, fit: "clamp" },
              alt: _vm.company.name,
              sizes: "140",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }